import transport from './transport'

export default [
  {
    path: '/logistics/waybills',
    name: 'LogisticWaybillList',
    component: () => import('@/views/Logistic/LogisticWaybillList.vue')
  },
  {
    path: '/logistics/waybills/:id',
    name: 'LogisticWaybillUpdate',
    component: () => import('@/views/Logistic/LogisticWaybillUpdate.vue')
  },
  {
    path: '/logistics/fuel',
    name: 'LogisticFuel',
    component: () => import('@/views/Logistic/LogisticFuel.vue')
  },
  {
    path: '/logistics/objects',
    name: 'LogisticObjectList',
    component: () => import('@/views/Logistic/LogisticObjectList.vue')
  },
  {
    path: '/logistics/objects/:id',
    name: 'LogisticObjectUpdate',
    component: () => import('@/views/Logistic/LogisticObjectUpdate.vue')
  },
  ...transport,
  {
    path: '/logistics/drivers',
    name: 'LogisticDriverList',
    component: () => import('@/views/Logistic/LogisticDriverList.vue')
  },
  {
    path: '/logistics/drivers/:id',
    name: 'LogisticDriverUpdate',
    component: () => import('@/views/Logistic/LogisticDriverUpdate.vue')
  },
  {
    path: '/logistics/reports',
    name: 'LogisticReports',
    component: () => import('@/views/Logistic/LogisticReports.vue')
  }
]
